module.exports = __webpack_public_path__ + "static/img/bg5.190cfa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg5.png
// module id = Plcd
// module chunks = 1